// import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
// import { User } from '../types';
// import { authAPI } from '../services/api';

// interface AuthContextType {
//   user: User | null;
//   isLoading: boolean;
//   login: (email: string, password: string) => Promise<User>; // was Promise<void>
//   logout: () => void;
//   isAdmin: boolean;
//   isBrand: boolean;
// }
// const AuthContext = createContext<AuthContextType | undefined>(undefined);

// export const AuthProvider = ({ children }: { children: ReactNode }) => {
//   const [user, setUser] = useState<User | null>(null);
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     const saved = localStorage.getItem('adroj_user');
//     if (saved) setUser(JSON.parse(saved));
//     setIsLoading(false);
//   }, []);

//   const login = async (email: string, password: string) => {
//   const { user: u, token } = await authAPI.login(email, password);
//   const normalizedUser = { ...u, role: u.role.toLowerCase() } as User;
//   localStorage.setItem('adroj_token', token);
//   localStorage.setItem('adroj_user', JSON.stringify(normalizedUser));
//   setUser(normalizedUser);
//   return normalizedUser;
// };

//   const logout = () => {
//     localStorage.removeItem('adroj_token');
//     localStorage.removeItem('adroj_user');
//     setUser(null);
//   };

//   return (
//     <AuthContext.Provider value={{ user, isLoading, login, logout, isAdmin: user?.role === 'admin', isBrand: user?.role === 'brand' }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => {
//   const ctx = useContext(AuthContext);
//   if (!ctx) throw new Error('useAuth must be used within AuthProvider');
//   return ctx;
// };



import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { User, UserRole } from '../types';
import { adminLogin } from '../services/authService'; // ✅ real API — replaces old mock authAPI

interface AuthContextType {
  user: User | null;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<User>;
  logout: () => void;
  isAdmin: boolean;
  isBrand: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // Rehydrate user from localStorage on first load (page refresh support).
  useEffect(() => {
    const saved = localStorage.getItem('adroj_user');
    if (saved) setUser(JSON.parse(saved));
    setIsLoading(false);
  }, []);

  const login = async (email: string, password: string): Promise<User> => {
    // ✅ adminLogin() hits POST /auth/admin-login, stores token + user in
    //    localStorage, and returns the result.
    const result = await adminLogin(email, password);

    // ✅ Normalize role casing once at this boundary ('Admin' → 'admin')
    //    so every role check in the app (ProtectedRoute, isAdmin, isBrand)
    //    works against a consistent lowercase value.
    const normalizedUser: User = {
      ...result.user,
      name: result.user.username,        // API returns 'username', User type expects 'name'
      role: result.user.role.toLowerCase() as UserRole,
    };

    // ✅ Persist normalized user so page-refresh rehydration above also gets
    //    the lowercase role (overwrite whatever authService stored).
    localStorage.setItem('adroj_user', JSON.stringify(normalizedUser));

    // ✅ Update context state — this is what ProtectedRoute reads.
    setUser(normalizedUser);

    return normalizedUser;
  };

  const logout = () => {
    localStorage.removeItem('adroj_token');
    localStorage.removeItem('adroj_user');
    localStorage.removeItem('adroj_access_token');
    localStorage.removeItem('adroj_refresh_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoading,
        login,
        logout,
        isAdmin: user?.role?.toLowerCase() === 'admin',
        isBrand: user?.role?.toLowerCase() === 'brand',
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};